import f3tch from 'f3tch';

import profile from '../../api/profiles/json.profile.api';

export default (query = {}) =>
  f3tch('/crm/teams/').profile(profile()).query(query).get();
